const SLIDE_GRID = {
    '1x1': { cols: 1, rows: 1 },
    '1x2': { cols: 2, rows: 1 },
    '2x1': { cols: 1, rows: 2 },
    '2x2': { cols: 2, rows: 2 },
    '3x1': { cols: 3, rows: 1 },
    '4x1': { cols: 4, rows: 1 },
}

export const getPopoverPlacement = (template, position) => {
    const grid = SLIDE_GRID[template] ?? { cols: 1, rows: 1 }
    const row = Math.floor(position / grid.cols)
    const flipVert = row >= Math.ceil(grid.rows / 2)
    return flipVert ? 'left-bottom' : 'left-top'
}

export const ICON_ONLY_TEMPLATES = new Set(['2x2', '4x1'])

export const countFilterRules = (ruleGroup) => (
    ruleGroup?.rules?.filter(({ ruleType }) => ruleType === 'rule').length ?? 0
)
